module.exports = __webpack_public_path__ + "img/h-page4-32.698d1941.png";